import { Injectable, Signal, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { layoutWindowBreakpoints } from '../../consts/layout-window-breakpoints';
import { OverlayDialogDevice } from './overlay-dialog-device.enum';

export const deviceBreakpoints = new Map<string, OverlayDialogDevice>([
    [`(max-width: ${layoutWindowBreakpoints.sm - 1}px)`, OverlayDialogDevice.Mobile],
    [`(max-width: ${layoutWindowBreakpoints.lg - 1}px)`, OverlayDialogDevice.Tablet]
]);

@Injectable({ providedIn: 'root' })
export class OverlayDialogService {
    private readonly breakpointObserver = inject(BreakpointObserver);
    private readonly openState = signal(false);
    public readonly isOverlayOpen: Signal<boolean> = this.openState.asReadonly();
    public readonly device: Signal<OverlayDialogDevice> = toSignal(
        this.breakpointObserver.observe([...deviceBreakpoints.keys()]).pipe(map(state => this.resolveDevice(state.breakpoints))),
        {
            initialValue: this.resolveDevice(
                Object.fromEntries([...deviceBreakpoints.keys()].map(query => [query, this.breakpointObserver.isMatched(query)]))
            )
        }
    );

    public open(): void {
        this.openState.set(true);
    }

    public close(): void {
        this.openState.set(false);
    }

    private resolveDevice(matches: Record<string, boolean>): OverlayDialogDevice {
        for (const [query, device] of deviceBreakpoints) {
            if (matches[query]) {
                return device;
            }
        }

        return OverlayDialogDevice.Desktop;
    }
}
